import React, { useEffect, useState } from 'react';
import rfmData from '../data/rfm.json';
import EchartDashbaord from './EchartDashboard';
import PaginationComponent from './PaginationComponent';


const RfmVisualization = () => {

    return (
        <div>
            <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-4">Recency Frequency Monetary Metrics</h3>
                <p className="text-gray-600 dark:text-gray-300 mb-6">Detailed analysis of model performance across different metrics and time periods.</p>

                {/* RFM Information Cards */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                    {/* RFM Explanation Card */}
                    <div className="bg-gray-100 dark:bg-gray-900 border border-blue-200 dark:border-blue-800 rounded-xl p-6">
                        <div className="flex items-center mb-4">
                            <div className="p-3 bg-blue-100 dark:bg-blue-900 rounded-lg mr-4">
                                <svg className="w-8 h-8 text-blue-600 dark:text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 00-2-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                </svg>
                            </div>
                            <div>
                                <h4 className="text-xl font-bold text-blue-800 dark:text-blue-200">Understanding RFM Analysis</h4>
                                <p className="text-blue-600  text-sm dark:text-blue-400">Recency • Frequency • Monetary</p>
                            </div>
                        </div>

                        <div className="space-y-4">
                            <div className="bg-white/60 dark:bg-white/10 rounded-lg p-4">
                                <h5 className="font-semibold text-red-700 dark:text-red-400 mb-2">📅 Recency (R)</h5>
                                <p className="text-sm text-gray-700 dark:text-gray-300">How recently a customer made a purchase. Recent customers are more likely to respond to marketing campaigns.</p>
                            </div>

                            <div className="bg-white/60 dark:bg-white/10 rounded-lg p-4">
                                <h5 className="font-semibold text-green-700 dark:text-green-400 mb-2">🔄 Frequency (F)</h5>
                                <p className="text-sm text-gray-700 dark:text-gray-300">How often a customer makes purchases. Frequent buyers show higher engagement and loyalty to your brand.</p>
                            </div>

                            <div className="bg-white/60 dark:bg-white/10 rounded-lg p-4">
                                <h5 className="font-semibold text-purple-700 dark:text-purple-400 mb-2">💰 Monetary (M)</h5>
                                <p className="text-sm text-gray-700 dark:text-gray-300">How much money a customer has spent. High-value customers contribute more to your revenue and profit.</p>
                            </div>

                            <div className="bg-blue-100 dark:bg-blue-800 rounded-lg p-3 mt-4">
                                <p className="text-sm text-blue-800 dark:text-blue-100 font-medium">
                                    📊 <strong>RFM Scores:</strong> Each dimension is rated from 1 to 5, where 5 represents the highest value (most recent, most frequent, highest monetary value) and 1 represents the lowest value.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Customer Segments Card */}
                    <div className="bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-gray-800 dark:to-gray-900 border border-emerald-200 dark:border-emerald-700 rounded-xl p-6">
                        <div className="flex items-center mb-4">
                            <div className="p-3 bg-emerald-100 dark:bg-emerald-800 rounded-lg mr-4">
                                <svg className="w-8 h-8 text-emerald-600 dark:text-emerald-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                            </div>
                            <div>
                                <h4 className="text-xl font-bold text-emerald-800 dark:text-emerald-200">Customer Segments</h4>
                                <p className="text-emerald-600 dark:text-emerald-400 text-sm">Based on RFM Analysis</p>
                            </div>
                        </div>

                        <div className="space-y-3 max-h-96 overflow-y-auto">
                            <div className="bg-white/90 dark:bg-white/10 rounded-lg p-3">
                                <div className="flex items-center justify-between mb-1">
                                    <h5 className="font-semibold text-yellow-600 dark:text-yellow-300">🏆 Champion</h5>
                                    <span className="text-xs bg-orange-100  text-orange-800  px-2 py-1 rounded">R = 1 and F = 5 and M = 5 </span>
                                </div>
                                <p className="text-xs text-gray-600 dark:text-gray-300">Recently active, frequent buyers who spend the most — your most valuable customers.</p>
                            </div>



                            <div className="bg-white/90 dark:bg-white/10 rounded-lg p-3">
                                <div className="flex items-center justify-between mb-1">
                                    <h5 className="font-semibold text-yellow-600 dark:text-yellow-300">🤝 Loyal</h5>
                                    <span className="text-xs bg-blue-100  text-blue-800  px-2 py-1 rounded">R ≤ 2 and F ≥ 4 and M ≥ 4</span>
                                </div>
                                <p className="text-xs text-gray-600 dark:text-gray-300">Repeat buyers who purchase often and consistently — responsive to engagement efforts.</p>
                            </div>

                            <div className="bg-white/90 dark:bg-white/10 rounded-lg p-3">
                                <div className="flex items-center justify-between mb-1">
                                    <h5 className="font-semibold text-yellow-600 dark:text-yellow-300">✨ New Customer</h5>
                                    <span className="text-xs bg-cyan-100  text-cyan-800  px-2 py-1 rounded">R ≤ 2 and F = 1 and M ∈ [1–5]  </span>
                                </div>
                                <p className="text-xs text-gray-600 dark:text-gray-300">First-time buyers who purchased recently — nurture them to build loyalty.</p>
                            </div>

                            <div className="bg-white/90 dark:bg-white/10 rounded-lg p-3">
                                <div className="flex items-center justify-between mb-1">
                                    <h5 className="font-semibold text-yellow-600 dark:text-yellow-300">🌟 Promising</h5>
                                    <span className="text-xs bg-indigo-100  text-indigo-800  px-2 py-1 rounded">R ≤ 3 and F ≤ 2 and M ≤ 3</span>
                                </div>
                                <p className="text-xs text-gray-600 dark:text-gray-300">Recent shoppers with lower frequency and spend — show potential for growth.</p>
                            </div>



                            <div className="bg-white/90 dark:bg-white/10 rounded-lg p-3">
                                <div className="flex items-center justify-between mb-1">
                                    <h5 className="font-semibold text-yellow-600 dark:text-yellow-300">⚠️ At Risk</h5>
                                    <span className="text-xs bg-orange-100  text-orange-800  px-2 py-1 rounded">R ≥ 4 and F ≥ 3 and M ≥ 3</span>
                                </div>
                                <p className="text-xs text-gray-600 dark:text-gray-300">Previously valuable customers who haven’t purchased in a while — need reactivation.</p>
                            </div>



                            <div className="bg-white/90 dark:bg-white/10 rounded-lg p-3">
                                <div className="flex items-center justify-between mb-1">
                                    <h5 className="font-semibold text-yellow-600 dark:text-yellow-300">💔 Lost</h5>
                                    <span className="text-xs bg-red-200  text-red-900  px-2 py-1 rounded">R ≥ 4 and F ≤ 2 and M ≤ 2</span>
                                </div>
                                <p className="text-xs text-gray-600 dark:text-gray-300">Inactive, low-spending customers — low engagement and low recent activity.</p>
                            </div>

                            <div className="bg-white/90 dark:bg-white/10 rounded-lg p-3">
                                <div className="flex items-center justify-between mb-1">
                                    <h5 className="font-semibold text-yellow-600 dark:text-yellow-300">🐻 Hibernating</h5>
                                    <span className="text-xs bg-gray-200  text-gray-900  px-2 py-1 rounded">R ∈ [2–4], F ∈ [2–3], M ∈ [2–4]</span>
                                </div>
                                <p className="text-xs text-gray-600 dark:text-gray-300">Customers with average engagement across all metrics — inactive but not completely lost.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <EchartDashbaord custData={rfmData} />


                <PaginationComponent />


            </div>

        </div>


    );
};

export default RfmVisualization;